export default __webpack_public_path__ + "static/media/ppt.ea1be4cf.png";